/* eslint-disable max-classes-per-file */
export class ColumnPlainObject {
    public columnType: ColumnType;
    public name: string;
}

export class ColumnType {
    public format: string;
    constructor(public columnType: string) {
    }
}

export class ColumnDecimalType extends ColumnType {
    public precision: number;
    public scale: number;

    constructor() {
        super('decimal');
    }
}

export class ColumnComplexType extends ColumnType {
    public fields: ColumnPlainObject[] = [];

    constructor() {
        super('complex');
    }
}

export class ColumnArrayType extends ColumnType {
    public arrayType: ColumnType;

    constructor() {
        super('array');
    }
}

export class ColumnMapType extends ColumnType {
    public keyType: ColumnType;
    public valueType: ColumnType;

    constructor() {
        super('map');
    }
}

export class ColumnExternalType extends ColumnType {
    public expression: string;

    constructor() {
        super('external');
    }
}
